import { render, staticRenderFns } from "./SuppliersInvoicesView.vue?vue&type=template&id=54ee6abc&"
import script from "./SuppliersInvoicesView.vue?vue&type=script&lang=js&"
export * from "./SuppliersInvoicesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports